<div class="showcase"></div>
<div class="content">
  <div class="title">Sircomedia</div>
  <div>
    <p class="text">
      Durante años he ido construyendo, poco a poco, un enorme castillo donde el
      arte, la creatividad y la risa se pasean por sus pasillos; este castillo
      se llama Sircomedia Group®.
    </p>
    <p class="text">
      Para mí es un placer presentarte este Olimpo Cómico, que nace para brindar
      espacios amplios y diversos para la comedia como forma de arte, y para
      cada uno de sus creadores.
    </p>
    <p class="text">
      Sircomedia Group®, junto con sus filiales —Sircomedia Productions,
      Sircomedia World, Sircomedia Help, Sircomedia Stars y Pechos de Héroe—, es
      una empresa de entretenimiento internacional, enfocada en desarrollar,
      producir y preservar contenidos de comedia para plataformas DTC, teatrales
      y lineales, con tres propósitos específicos: Entretener, Educar y Ayudar.
    </p>
  </div>
  <div class="seccion-fotos">
    <div class="sub-title">Productos Sircomedia</div>
    <p class="text">
      Justo en el instante en el que se produce una carcajada comienza nuestro
      universo.
    </p>
    <div class="reel-fotos">
      <swiper [config]="configReelPhotos">
        <div class="r-photo" *ngFor="let photo of reelPhotos">
          <img [src]="reelPhotosPath + photo" alt="" />
        </div>
      </swiper>
    </div>
    <!-- <button class="button-box" mat-button>Descargar Book ↓</button> -->
  </div>

  <button class="button-box w-arrow visita-sircomedia" mat-button>
    Visita Sircomedia
    <mat-icon class="arrow-right">arrow_right_alt</mat-icon>
  </button>
  <go-to-top></go-to-top>
</div>
<who-fran-want></who-fran-want>
